import { Observable } from 'rxjs';
import { VehicleDocument } from '../data/models/document.model';
import { PagedList } from '../data/models/paged-list.model';
import { SortModel } from '../data/models/sort-model.model';
import { Vehicle } from '../data/models/vehicle.model';
import httpService from './httpService';

class VehicleService {
  private readonly apiBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_VEHICLE_API_URL.trim();
  }

  public findVehicles(
    pageSize: number,
    page: number,
    filter: string,
    search: string,
    sortModel: SortModel | null,
    providerId?: number,
  ): Observable<PagedList<Vehicle>> {
    const f = encodeURIComponent(filter);
    const s = encodeURIComponent(search);
    let url = `${this.apiBase}?page=${page}&pageSize=${pageSize}&filter=${f}&search=${s}`;
    if (sortModel) {
      url += `&sort=${sortModel.column}&sortOrder=${sortModel.direction}`;
    }
    if (providerId) {
      url += `&provider=${providerId}`;
    }
    return httpService.getJSON(url);
  }

  public getVehicle(id: number): Observable<Vehicle> {
    return httpService.getJSON(`${this.apiBase}/${id}`);
  }

  public createVehicle(vehicle: Vehicle): Observable<Vehicle> {
    const url = this.apiBase;
    return httpService.postJSON(url, vehicle);
  }

  public updateVehicle(vehicle: Vehicle): Observable<Vehicle> {
    const url = `${this.apiBase}/${vehicle.vehicleID}`;
    return httpService.putJSON(url, vehicle);
  }

  public deleteVehicle(vehicleId: number): Observable<Vehicle> {
    const url = `${this.apiBase}/${vehicleId}`;
    return httpService.deleteJSON(url);
  }

  public uploadVehicleDocument(
    vehicleId: number,
    document: VehicleDocument,
    file: any,
  ): Observable<VehicleDocument> {
    const url = `${this.apiBase}/${vehicleId}/documents`;
    const formData = new FormData();
    formData.append('document', file, file.name);
    formData.append(
      'vehicleDocumentTypeID',
      '' + document.vehicleDocumentTypeID,
    );
    if (document.signedOnDate) {
      formData.append('signedOnDate', document.signedOnDate);
    }
    if (document.effectiveStartDate) {
      formData.append('effectiveStartDate', document.effectiveStartDate);
    }
    if (document.effectiveEndDate) {
      formData.append('effectiveEndDate', document.effectiveEndDate);
    }

    return httpService.postJSON(url, formData, true);
  }

  public updateVehicleDocument(
    providerId: number,
    document: VehicleDocument,
  ): Observable<VehicleDocument> {
    const url = `${this.apiBase}/${providerId}/documents/${document.vehicleDocumentID}`;
    return httpService.putJSON(url, document);
  }

  public deleteVehicleDocument(
    providerId: number,
    documentId: number,
  ): Observable<VehicleDocument> {
    const url = `${this.apiBase}/${providerId}/documents/${documentId}`;
    return httpService.deleteJSON(url);
  }

  public getVehicleDocuments(vehicleId: number): Observable<VehicleDocument[]> {
    const url = `${this.apiBase}/${vehicleId}/documents`;
    return httpService.getJSON(url);
  }

  public importVehicles(
    providerId: number,
    vehicleFile: any,
  ): Observable<void> {
    const url = `${this.apiBase}/bulk`;
    const formData = new FormData();
    formData.append('document', vehicleFile, vehicleFile.name);
    formData.append('ProviderID', '' + providerId);
    return httpService.postJSON(url, formData, true);
  }
}

const vehicleService = new VehicleService();

export default vehicleService;
